import { render, staticRenderFns } from "./xtButtonWeb.vue?vue&type=template&id=14480cfe&scoped=true&"
import script from "./xtButtonWeb.vue?vue&type=script&lang=js&"
export * from "./xtButtonWeb.vue?vue&type=script&lang=js&"
import style0 from "./xtButtonWeb.vue?vue&type=style&index=0&id=14480cfe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14480cfe",
  null
  
)

export default component.exports